import API from './API'
import {
  EXECUTIONS_ACCEPTED,
  EXECUTIONS_API,
  EXECUTIONS_POST_API,
  EXECUTIONS_REFUS_API,
  UPLOAD_PHOTO_API,
} from '../constants/Constants'

function getExecutions(
  type,
  sortType,
  sortOrder,
  currentPage,
  searchText,
  dateDebut,
  dateFin,
) {
  return API({
    name: 'exécutions',
    method: 'get',
    url: `${EXECUTIONS_API}?type=${type}${
      type === 'by-last-days' ? '&days=30' : ''
    }${
      type === 'search'
        ? `&numcdelocalite=${searchText || ''}&date_debut=${
            dateDebut || ''
          }&date_fin=${dateFin || ''}`
        : ''
    }&orderBy=${sortType}&way=${
      sortOrder || 'desc'
    }`,
    headers: {
      accept: 'application/ld+json',
    },
    female: true,
  });
}

async function postExecutions(data) {
  return API({
    name: 'post_executions',
    method: 'post',
    url: `${EXECUTIONS_POST_API}`,
    data,
  })
}

async function uploadPicture(numcde, data) {
  return API({
    name: 'upload_photo',
    method: 'post',
    url: `${UPLOAD_PHOTO_API}?numcde=${numcde}`,
    data,
  })
}

function getRefus() {
  return API({
    name: 'refus',
    method: 'get',
    url: EXECUTIONS_REFUS_API,
    single: true,
  })
}

function getAcceptedExecutions(async = false) {
  const request = {
    name: 'accepted_execution',
    method: 'get',
    url: EXECUTIONS_ACCEPTED,
  };

  return async ? API(request) : request;
}

function getAllAcceptedExecutions(dateStart, dateEnd) {
  return API({
    name: 'accepted_execution',
    method: 'get',
    url: `${EXECUTIONS_ACCEPTED}/all?date_start=${dateStart}&date_end=${dateEnd}`
  });
}

export default {
  getExecutions,
  postExecutions,
  getRefus,
  uploadPicture,
  getAcceptedExecutions,
  getAllAcceptedExecutions,
}
